import React from 'react'
import './Boost.css'

export default function Boost() {
  return (
    <div className='boost-container'>
      <h1 className='title'>Boost your links today</h1>
      <button className='btn'>Get Started</button>
    </div>
  )
}
